import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { LayerBackendService } from '../../shared/services/layer-backend.service';

export interface FeedBalanceRow {
  deliveryLineId: number;
  deliveryDate: string;
  externalDeliveryId?: string | null;
  externalOrderId?: string | null;
  deliveryNote: string;
  lineNumber: string;
  productCode: string;
  productTitle: string;
  deliveredQuantity: number;
  deliveredKg?: number | null;
  deliveredUnit: string;
  isActive: boolean;
  isMissing: boolean;
  usedKg: number | null;
}
export interface FeedBalanceStatus {
  flockId: number;
  savedAt: string | null;
  revision: number;
}
export interface FeedBalance extends FeedBalanceStatus {
  rows: FeedBalanceRow[];
}
export interface SaveFeedBalance {
  revision: number;
  allocations: { deliveryLineId: number; usedKg: number }[];
}

@Injectable({ providedIn: 'root' })
export class FeedBalanceService {
  private readonly http = inject(HttpClient);
  private readonly backend = inject(LayerBackendService);

  private url(flockId: number): string {
    return `${this.backend.flockBaseUrl}/${flockId}/feed-balance`;
  }

  get(flockId: number) {
    return this.http.get<FeedBalance>(this.url(flockId));
  }

  status(flockId: number) {
    return this.http.get<FeedBalanceStatus>(`${this.url(flockId)}/status`);
  }

  save(flockId: number, request: SaveFeedBalance) {
    return this.http.put<FeedBalance>(this.url(flockId), request);
  }
}
